import {
    CodeBlock, BlockType, SettingType, ValidationMessage, SettingState, TibboDataType, Define,
} from '@appblocks/codegeneration/types';

import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import { TIBBO_DEVICE_ID } from '@appblocks/platforms/PlatformUtils';
import FeatureUtils from '@appblocks/codegeneration/FeatureUtils';
import * as tios from './tios';

export default class FirmwareUpgrade extends BaseFeature {
    constructor() {
        super();
        this.name = 'Firmware Upgrade';
        this.id = 'firmware_upgrade';
        this.requirements = ['tios'];
        this.files = [
            'libraries/upgrade/upgrade.tbh',
            'libraries/upgrade/upgrade.tbs',
            'upload_firmware.html',
            'upload_progress.html',
        ];
    }

    getEnabled(): boolean {
        return FeatureUtils.isSupported(this, this.project);
    }

    getDependencies(): string[] {
        return [
            'fd',
            'http',
        ];
    }

    getDefines(): Define[] {
        return [
            {
                name: 'CTS_MAP',
                value: '0',
            },
            {
                name: 'RTS_MAP',
                value: '0',
            },
            {
                name: 'HTTP_TX_BUFF',
                value: '10',
            },
            {
                name: 'HTTP_RX_BUFF',
                value: '10',
            },
            {
                name: 'FIRMWARE_UPGRADE_FILENAME',
                value: '"firmware.bin"',
            },
        ];
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'tios':
                return tios.getCodeBlocks(this);
            default:
                return [];
        }
    }

    getDetails(): string {
        return `
### Firmware Upgrade`;
    }
}
